import { callApi, IApiErrorResponse } from '@/api/callApi';
import { API_ENDPOINT, API_URL } from '@/api/constant';
import EyeCloseIcon from '@/components/Icons/EyeCloseIcon';
import EyeOpenIcon from '@/components/Icons/EyeOpenIcons';
import PasswordIcon from '@/components/Icons/PasswordIcons';
import AuthLayout from '@/components/Layout/AuthLayout';
import Button from '@/components/ui/Button';
import PrimaryInput from '@/components/ui/PrimaryInput';
import { showToastNotification } from '@/utility/helper';
import { RoutesLink } from '@/utility/RouteLinks';
import { useState } from 'react';
import { SubmitHandler, useForm } from 'react-hook-form';
import { useLocation, useNavigate } from 'react-router-dom';
import { Spinner } from 'reactstrap';
interface INewPasswordForm {
  password: string;
  confirmPassword: string;
}
interface INewPasswordResponse {
  status: boolean;
  message: string;
}

const NewPassword = () => {
  const navigate = useNavigate();
  const [showNewPassword, setShowNewPassword] = useState(false);
  const location = useLocation();
  const togglePasswordVisibility = () => {
    setShowNewPassword(!showNewPassword);
  };
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const toggleConfirmPasswordVisibility = () => {
    setShowConfirmPassword(!showConfirmPassword);
  };
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const {
    register,
    handleSubmit,
    formState: { errors },
    watch,
  } = useForm<INewPasswordForm>();

  const onSubmit: SubmitHandler<INewPasswordForm> = async (data) => {
    setIsLoading(true);
    try {
      let deviceId = '';
      if (localStorage.getItem('deviceId')) {
        deviceId = localStorage.getItem('deviceId') ?? '';
      } else {
        deviceId = '2024_';
      }
      localStorage.setItem('deviceId', deviceId);
      const fcmToken = localStorage.getItem(
        import.meta.env.VITE_BUSINESS + 'fcmToken',
      );

      const submitData = {
        ...(location?.state?.data?.email && {
          email: location?.state?.data?.email,
        }),
        password: data?.password,
        deviceId: deviceId,
        deviceToken: fcmToken ? fcmToken : null,
      };

      const API = `${API_URL}${API_ENDPOINT?.forgetPassword}`;
      const response: INewPasswordResponse = await callApi(API, {
        method: 'POST',
        data: submitData,
      });
      setIsLoading(false);
      if (response?.status === true) {
        showToastNotification('success', response?.message);
        navigate(RoutesLink?.Login);
      } else {
        showToastNotification('danger', response?.message);
      }
    } catch (error) {
      if (error && typeof error === 'object' && 'message' in error) {
        showToastNotification('danger', (error as IApiErrorResponse).message);
      } else {
        showToastNotification('danger', 'Something went wrong');
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <AuthLayout>
      <div className="d-flex justify-content-center align-items-center ">
        <div className="p-md-5 p-3 mx-2 mx-md-0  auth ">
          <h1 className="title">New password</h1>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="row">
              <div className="col-12">
                <div className="form-group mb-3 mt-3">
                  <PrimaryInput
                    label="New password"
                    type={showNewPassword ? 'text' : 'password'}
                    id={'login_password'}
                    placeholder="Enter new password"
                    {...register('password', {
                      required: 'Please enter a valid password',
                    })}
                    errors={errors?.password?.message}
                    startIcon={<PasswordIcon />}
                    passwordShow={
                      <div className="password-show">
                        <div
                          // type="button"
                          className=""
                          onClick={togglePasswordVisibility}
                          style={{ fontSize: '14px' }}
                        >
                          {showNewPassword ? <EyeOpenIcon /> : <EyeCloseIcon />}
                        </div>
                      </div>
                    }
                  />
                </div>
              </div>
              <div className="col-12">
                <div className="form-group mb-3">
                  <PrimaryInput
                    label="Confirm password"
                    placeholder="Enter confirm password"
                    type={showConfirmPassword ? 'text' : 'password'}
                    // placeholder="Confirm password"
                    id="correctpass"
                    {...register('confirmPassword', {
                      required: 'Please confirm your password',
                      validate: (value) =>
                        value === watch('password') || 'Passwords do not match',
                    })}
                    errors={errors?.confirmPassword?.message}
                    startIcon={<PasswordIcon />}
                    passwordShow={
                      <div className="password-show">
                        <div
                          // type="button"
                          className=""
                          onClick={toggleConfirmPasswordVisibility}
                          style={{ fontSize: '14px' }}
                        >
                          {showConfirmPassword ? (
                            <EyeOpenIcon />
                          ) : (
                            <EyeCloseIcon />
                          )}
                        </div>
                      </div>
                    }
                  />
                </div>
              </div>
            </div>
            <div className="d-grid gap-4 btns">
              <Button
                disabled={isLoading}
                type="submit"
                className="btn btn-primary w-100 fs-4 fw-semibold py-2 mt-3 text-white"
              >
                {isLoading ? <Spinner /> : 'Create new password'}
              </Button>
            </div>
          </form>
        </div>
      </div>
    </AuthLayout>
  );
};

export default NewPassword;
